import * as admin from '@hunk/shared/api/admin';
import * as apiAuth from '@hunk/shared/api/apiAuth';
import * as billing from '@hunk/shared/api/billing';
import * as orders from '@hunk/shared/api/orders';
import * as pages from '@hunk/shared/api/pages';
import * as selfUser from '@hunk/shared/api/selfUser';
import * as shop from '@hunk/shared/api/shop';

/** Every client -> server call, grouped like the server routers (/api/auth, /api/self, /api/shop, /api/orders ...). */
export const api = {
  admin,
  auth: apiAuth,
  billing,
  orders,
  pages,
  selfUser,
  shop
};
export type ApiType = typeof api;
